// extracted by mini-css-extract-plugin
export default {"wrapper":"aNm2_jTo_nobqsBmFmDS","errorAlert":"AZJPlMaHwGDaYl4nDl5r"};